<template>
  <unicom-menu-geral v-unicom-click-outside="blur">
    <unicom-campo-texto
      tipoCampo="search"
      :id="id"
      v-model="valorCampo"
      :titulo="titulo"
      :desativado="desativado"
      :icone="currentIcon"
      :placeholder="placeholder"
      :colorPlaceholder="colorPlaceholder"
      ladoIcone="direito"
      :mensagemErro="mensagemErro"
      :clickIcone="mostrarIconeExcluir && valorCampo.length > 0"
      @click-icone="limparCampo"
      @eventoCampo="mostrarMenuItem = true"
      @click="abrirMenu"
    />
    <menu-item-vue
      :valorAtual="valorData"
      :largura="larguraMenuProp"
      :items="itemsComputed"
      :textoDoItem="textoDoItem"
      :usarTamanhoAutomatico="usarTamanhoAutomatico"
      :alturaMaximaMenu="alturaMaximaMenu"
      v-model="mostrarMenuItem"
      @select="value => eventoCampo(value)"
    />
  </unicom-menu-geral>
</template>

<script>
import { normalizeText, isObject } from "./helper";

import MenuItemVue from "./MenuItem/MenuItem.vue";

export default {
  model: {
    prop: "valorData",
    event: "input"
  },

  components: {
    MenuItemVue
  },

  props: {
    id: {
      default: null,
      note: "Identificador do ID"
    },
    valorData: {
      type: [String, Number, Boolean, Array, Object],
      required: true,
      note:
        "Valor padrão para todos os componentes que precisarem de alguma estrutura de v-model. Recebendo o valor e enviando para o parente."
    },
    titulo: {
      type: String,
      default: "",
      note: "Título do campo."
    },
    placeholder: {
      type: String,
      default: "",
      note: "Placeholder do input."
    },
    desativado: {
      type: Boolean,
      default: false,
      note: "Indica se o campo vai ficar desabilitado."
    },
    items: {
      type: [Array, String],
      required: true,
      note: "Array de Objetos dos items para listar."
    },
    textoDoItem: {
      type: String,
      default: null,
      note: "property in item for text."
    },
    filtro: {
      type: Function,
      default: (item, queryText, textoDoItem) => {
        const hasValue = val => (val != null ? val : "");

        const text = hasValue(normalizeText(textoDoItem));
        const query = hasValue(normalizeText(queryText));

        return (
          text
            .toString()
            .toLowerCase()
            .indexOf(query.toString().toLowerCase()) > -1
        );
      },
      note: "Filtro de pesquisar."
    },
    larguraMenuProp: {
      type: [String, Number],
      required: false,
      note: "Largura do menu"
    },
    colorPlaceholder: {
      type: String,
      required: false,
      default: "#707070",
      note: "Cor do placeholder"
    },
    mensagemErro: {
      type: String,
      default: null,
      note: "Mensagem de erro."
    },
    usarTamanhoAutomatico: {
      type: Boolean,
      default: false,
      note: "Usar tamanho automatico do menuItem"
    },
    mostrarIconeExcluir: {
      type: Boolean,
      default: false
    },
    alturaMaximaMenu: {
      type: [String, Number],
      required: false,
      default: 220,
      note: "Altura máxima dos itens dentro do menu."
    }
  },

  data() {
    return {
      valorCampo: this.valorData,
      mostrarMenuItem: false,
      itemSelecionado: true
    };
  },

  methods: {
    abrirMenu() {
      this.mostrarMenuItem = !this.mostrarMenuItem;
    },
    pegaValorTexto() {
      return this.valorCampo;
    },
    filtragemDosItems(items) {
      if (!this.pegaValorTexto() || !this.mostrarMenuItem) return items;
      return items.filter(i =>
        this.filtro(i, this.pegaValorTexto(), this.pegaTextoDoItem(i.descricao))
      );
    },
    pegaTextoDoItem(item) {
      if (!item) return null;
      if (this.textoDoItem) return item[this.textoDoItem];
      if (isObject(item)) {
        const keys = Object.keys(item);
        if (keys.length === 1) {
          return item[keys[0]];
        }
        return item;
      }
      return item;
    },

    blur() {
      if (!this.mostrarMenuItem) return;
      this.itemSelecionado = true;
      this.mostrarMenuItem = false;
      this.$emit("blur");
    },

    eventoCampo(value) {
      this.itemSelecionado = false;
      this.valorCampo = value;
    },

    limparCampo() {
      this.itemSelecionado = false;
      this.valorCampo = "";
      this.$emit("blur");
      this.$emit("limpar-campo");
    }
  },

  watch: {
    valorData() {
      this.valorCampo = this.valorData;
    },
    valorCampo() {
      this.itemSelecionado = false;
      const item = this.itemsComputed.find(i => i.descricao == this.valorCampo);
      const index = this.itemsComputed.indexOf(item);
      if (index === -1 && !["", null].includes(this.valorCampo)) return;
      this.$emit("index", index);
      this.$emit("input", this.valorCampo);
    }
  },

  computed: {
    itemsComputed() {
      let items = this.items;

      if (this.itemSelecionado) return this.items;

      if (typeof this.items === "string") {
        items = JSON.parse(this.items);
      }

      return this.filtragemDosItems(items);
    },
    currentIcon() {
      if (this.mostrarIconeExcluir && this.valorCampo) {
        return "x";
      }
      return this.mostrarMenuItem ? "chevron-up" : "chevron-down";
    }
  }
};
</script>
